import React, {memo} from 'react';
import {UiCenter, UiSpinner} from '.';

interface Props {
  text?: string;
}

export const UiPageLoading = memo(function UiPageLoading({text = 'Loading'}: Props) {
  return (
    <UiCenter className="height-100-vh">
      <UiSpinner size="xl" label={text} />
    </UiCenter>
  );
});
